/**
 * Simple DataTables Initialization
 *
 * @link https://github.com/fiduswriter/Simple-DataTables
 */

import {DataTable} from 'simple-datatables';

// Simple DataTables
const dataTable = document.querySelector("#dataTable");
if (dataTable) {
    renderDataTable(dataTable)
}

function renderDataTable(dataTable) {
    window.jmulibDataTable = new DataTable(dataTable, {
        columns: [
            {
                select: 0,
                sort: 'asc'
            }
        ],
        fixedColumns: false,
        paging: false,

        // Modify the template to only include the table
        // Default template: https://fiduswriter.github.io/simple-datatables/documentation/template
        template: (options) => `
            <div class='${options.classes.container}'></div>
        `
    });

    // Reveal table after init
    window.jmulibDataTable.on('datatable.init', () => {
        document.getElementById('dataTable').style.opacity = '1'
    })

    // Search
    const tableSearch = document.getElementById('dataTableSearch')
    if (tableSearch) {
        tableSearch.addEventListener('input', e => {
            window.jmulibDataTable.search(e.target.value)
        })
    }
}
